/* tslint:disable:max-line-length */
import { SegmentSpecificMessages } from "../../types/types";

export const seniorMessages: SegmentSpecificMessages = {
  emailExplanation: "Personal email address is recommended",
  step: {
    personalInfo: {
      title: "Unlock Your Special Offer",
      subtitle: "Verify your current age.",
      howDoesVerifyingWorkDetails:
        "To be eligible for this offer, you must be of a certain age." +
        "<br></br>" +
        "{companyName} uses SheerID, a trusted partner, to verify your age. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: "Check Your Name & Birthdate",
        subtitle:
          "Your full name and birthdate must match what is on your government-issued documents.",
      },
      verifyingTitle: "Verifying your age",
      submitButtonText: "Verify and continue",
    },
    docUpload: {
      uploadInstructions: "Upload a government-issued document that shows",
      title: "To continue, upload documents that confirm your age",
      whoIsSheerId:
        "Document review is handled by SheerID, a trusted partner who specializes in verifying age.",
    },
    success: {
      title: "You've been verified",
      subtitle: "You are now eligible for this special offer.",
      redirectButtonText: "Continue",
    },
  },
};
